import React, { useState } from 'react';
import UDSLOGO from '../../../Assets/logo/logoWhite.svg'
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';


const Header = ({ active }) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const { accounts, instance } = useMsal();
    const navigate = useNavigate();
    const handleLogout = () => {
        instance.logout().then(() => {
            localStorage.clear();
            sessionStorage.clear();
            navigate('/');
        }).catch(e => {
            console.error(e);
        });
    };
    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };
    function stringToColor(string) {
        let hash = 0;
        let i;

        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }

        return color;
    }

    function stringAvatar(name) {
        return {
            sx: {
                bgcolor: stringToColor(name),
            },
            children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
        };
    }
    return (
        <div className='w-full'>
            <div className='w-screen bg-[#002746] text-white py-4 pb-[60px] flex'>
                <div className='px-2  flex items-center gap-[8px] w-[13%]'>
                    <img src={UDSLOGO} alt='' className='w-[40px] h-[40px]' />
                    <h1 className='text-[16px]'><strong>Unified Dev Suite</strong></h1>
                </div>
                <div className='flex justify-between w-full px-4'>
                    <div className='flex flex-col'>
                        <span className='text-white text-lg projection:text-3xl'>Contriubutor</span>
                        <span className='text-[#0077CF] text-sm leading-5 font-bold'>{active}</span>
                    </div>
                    <div className=''>
                        <div className='flex gap-4 items-center'>
                            <div className='text-white'>
                                <p className='py-1'>Hi {accounts[0].name}</p>
                            </div>
                            <div className='flex items-center'>
                                <Avatar {...stringAvatar(accounts[0].name)} sx={{ width: 35, height: 35, bgcolor: '#0D53AA', fontSize: '16px' }} onClick={handleMenuOpen} />
                                <ArrowDropDownIcon sx={{ color: 'white', cursor: 'pointer' }} onClick={handleMenuOpen} />
                                <Menu
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={handleMenuClose}
                                    sx={{ marginTop: 1, marginRight: 1 }}
                                >

                                    <MenuItem onClick={handleMenuClose} sx={{ padding: 0 }}>
                                        <button onClick={handleLogout} className="w-full text-black py-2 px-4">Logout</button>
                                    </MenuItem>

                                </Menu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Header